import IPreRaceScreeningPageState from "interfaces/PreRaceScreeningPageState";
import { SortOrder } from "interfaces/SortOrder";
import { preRacesTableTabs } from "pages/PreRaceScreeningPage/options";
import { EPreRaceTableSortingField } from "pages/PreRaceScreeningPage/types";
import {
  ADD_ASSIGN_CHECKED_ID,
  CLEAR_ASSIGN_CHECKED_IDS,
  REMOVE_ASSIGN_CHECKED_ID,
  SET_FACILITY_BARNS,
  SET_ORDER_BY,
  SET_SEARCH_VALUE,
  SET_SELECTED_DATE_RANGE,
  SET_SELECTED_PRE_RACE_FACILITY,
  SET_SELECTED_PRE_RACE_TABLE_TAB,
  SET_SHOW_ASSIGNED_TO_ME_ONLY,
  SET_SHOW_PASSED_ENTRIES_CHECKBOX_STATE,
  SET_SORT_ORDER,
  SET_UPCOMING_RACE_LIST_REQUEST_KEY,
  TPreRaceScreeningAction
} from "store/actions/preRaceScreeningPage";

const initialState: IPreRaceScreeningPageState = {
  selectedTab: preRacesTableTabs[0],
  searchValue: "",
  order: SortOrder.ASC,
  orderBy: EPreRaceTableSortingField.RACE_DATE,
  selectedFacility: null,
  showPassedEntries: false,
  facilityBarns: [],
  assignCheckedIds: [],
  showAssignedToMeOnly: false,
  upcomingRaceListRequestKey: null,
  selectedDateRange: null
};

export default (
  state = initialState,
  action: TPreRaceScreeningAction
): IPreRaceScreeningPageState => {
  switch (action.type) {
    case SET_SELECTED_PRE_RACE_TABLE_TAB: {
      return {
        ...state,
        selectedTab: action.selectedTab
      };
    }
    case SET_SELECTED_PRE_RACE_FACILITY: {
      return {
        ...state,
        selectedFacility: action.selectedFacility
      };
    }
    case SET_SHOW_PASSED_ENTRIES_CHECKBOX_STATE: {
      return {
        ...state,
        showPassedEntries: action.isChecked
      };
    }
    case SET_SORT_ORDER: {
      return {
        ...state,
        order: action.order
      };
    }
    case SET_ORDER_BY: {
      return {
        ...state,
        orderBy: action.orderBy
      };
    }
    case SET_SEARCH_VALUE: {
      return {
        ...state,
        searchValue: action.searchValue
      };
    }
    case SET_FACILITY_BARNS: {
      return {
        ...state,
        facilityBarns: action.barns
      };
    }
    case ADD_ASSIGN_CHECKED_ID: {
      return {
        ...state,
        assignCheckedIds: [...state.assignCheckedIds, action.checkedId]
      };
    }
    case REMOVE_ASSIGN_CHECKED_ID: {
      return {
        ...state,
        assignCheckedIds: state.assignCheckedIds.filter(
          id => id !== action.unCheckedId
        )
      };
    }
    case CLEAR_ASSIGN_CHECKED_IDS: {
      return {
        ...state,
        assignCheckedIds: []
      };
    }
    case SET_SHOW_ASSIGNED_TO_ME_ONLY: {
      return {
        ...state,
        showAssignedToMeOnly: action.showAssignedToMeOnly
      };
    }
    case SET_UPCOMING_RACE_LIST_REQUEST_KEY: {
      return {
        ...state,
        upcomingRaceListRequestKey: action.key
      };
    }
    case SET_SELECTED_DATE_RANGE:
      return {
        ...state,
        selectedDateRange: action.selectedDateRange
      };
    default:
      return state;
  }
};
